import { useState, useCallback } from "react";
import { DiskAnalysisService } from "../../../application/services/aiServices/diskAnalysisService";

const diskAnalysisService = new DiskAnalysisService();

export const useDiskAnalysis = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [diskAnalysis, setDiskAnalysis] = useState(null);

  const getDiskAnalysis = useCallback(async (vmId) => {
    setLoading(true);
    setError(null);
    try {
      const result = await diskAnalysisService.getDiskAnalysis(vmId);
      if (result.success) {
        setDiskAnalysis(result.data);
        return { success: true, data: result.data };
      } else {
        setError(result.message);
        return { success: false, message: result.message };
      }
    } catch (error) {
      setError(error.message);
      return { success: false, message: error.message };
    } finally {
      setLoading(false);
    }
  }, []);

  const analyzeAllVmsDisks = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const result = await diskAnalysisService.analyzeAllVmsDisks();
      if (result.success) {
        return { success: true, data: result.data };
      } else {
        setError(result.message);
        return { success: false, message: result.message };
      }
    } catch (error) {
      setError(error.message);
      return { success: false, message: error.message };
    } finally {
      setLoading(false);
    }
  }, []);

  return {
    getDiskAnalysis,
    analyzeAllVmsDisks,
    diskAnalysis,
    loading,
    error,
  };
};